
const EmailCode = -1;
const CPFCode = -2;
const NomeCode = -3;
const telefoneCode = -4;
const userCode = -5;

const CODE = {
    EmailCode,
    CPFCode,
    NomeCode,
    telefoneCode,
    userCode,
}

export default CODE;